<script lang="ts">
	import { MessagesSquare } from 'lucide-svelte';

	import { goto, invalidate, preloadCode } from '$app/navigation';

	import { Button } from '$lib/components/ui/button';

	import { analytics } from '$lib/analytics';
	import { createNewDefaultChat } from '$lib/chats';
	import * as m from '$lib/paraglide/messages';
	import { clientRepo } from '$lib/states/client-repo.svelte';

	import FeatureList from './feature-list.svelte';

	let busy = $state(false);
</script>

<div class="grid gap-8">
	<div class="prose">
		<h1 class="gradient-heading text-center text-balance max-w-[12ch] mx-auto my-8">
			{m.landingPage_heroText()}
		</h1>
	</div>

	<div class="prose">
		<p class="text-center text-balance mx-auto max-w-lg">
			{m.landingPage_heroDescription({ productName: m.productName() })}
		</p>
	</div>

	{@render chatCta({ position: 'top' })}

	<FeatureList />

	{@render chatCta({ position: 'bottom' })}
</div>

{#snippet chatCta({ position }: { position: 'top' | 'bottom' })}
	{#if clientRepo.repo}
		<div class="flex justify-center">
			<Button
				size="lg"
				onpointerenter={() => {
					preloadCode('/collections/chats/*');
				}}
				disabled={busy || !clientRepo.repo}
				onclick={async (evt) => {
					evt.preventDefault();

					analytics.capture({
						category: 'landing_page',
						target: 'new_chat_cta',
						verb: 'click',
						data: { position }
					});

					busy = true;
					try {
						const chat = await createNewDefaultChat();
						await goto(`/collections/chats/${chat.id}#bottom`);
						invalidate('chats:recent');
					} finally {
						busy = false;
					}
				}}
			>
				<MessagesSquare />

				{m.landingPage_startNewChatCta()}
			</Button>
		</div>
	{/if}
{/snippet}
